/**
 * One-shot notices between same-origin tabs, carried by localStorage: writing a key fires the
 * `storage` event in every *other* open tab (never in the writer). The notice is best-effort:
 * storage can be blocked or full, and whatever follows the announcement in the writing tab (a
 * reload, a logout submit) must still happen.
 */
export function announceToOtherTabs(key: string, value?: string): void {
    try {
        localStorage.setItem(key, value === undefined ? String(Date.now()) : `${value}@${Date.now()}`);
    } catch {
        // Storage unavailable; other tabs will catch up on their next visit instead.
    }
}

export function onSignalFromOtherTab(key: string, callback: (newValue: string | null) => void): void {
    globalThis.addEventListener("storage", (event: StorageEvent) => {
        if (event.key === key) {
            callback(event.newValue);
        }
    });
}
